module.exports = require("github:jspm/nodelibs-buffer@0.1.0/index");